/**
 * Pie Chart
 *
 * Custom Properties
 * {boolean} [fullWidth=false] should the pie chart appear on the full width with no datalabels and legend
 *
 */
import { Chart } from "common/components/charts/chart";

export const PieChart = Chart.extend({
    chartType: "pie",
    constructor: function constructor() {
        Chart.apply(this, arguments);
        if (this.getOption("fullWidth")) {
            this.extendChartOptions({
                chart: {
                    margin: [0, 0, 0, 0],
                    spacingTop: 0,
                    spacingBottom: 0,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: false
                        },
                        size: "100%"
                    }
                }
            });
        }
    },
    
    /**
     * Add amount or count tooltip formatter
     * @param {string} valueType Either `amount` or `count`
     * @private
     */
    addTooltipFormatter(valueType) {
        const self = this;
        
        this.extendChartOptions({
            tooltip: {
                formatter() {
                    const value = self[valueType === "amount" ? "formatAmountWithCurrentCurrency" : "formatNumber"](this.y);
                    return `${this.key} <br/> ${value} (${self.formatNumber(this.percentage, 2)}%)`;
                }
            }
        });
    },
    
    initialize() {
        this.listenTo(this.collection, "before:fetch", this.showLoader);
        this.listenTo(this.collection, "fetched", this.render);
        this.listenTo(this.collection, "filtered", this.render);
    }
});
